import { render } from "./MainHeader.vue?vue&type=template&id=2f5d5e9a"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=2f5d5e9a&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__